import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from './../store'
import LoginView from '@/auth/LoginView.vue'
import RegisterView from '@/auth/RegisterView.vue'
import AccountVerify from '@/auth/AccountVerify.vue'
import HomeViewClient from '@/views/HomeView.vue'
import CallbackView from '@/views/CallbackView.vue'
import IndexCourse from '../views/operations/courses/IndexCourse.vue'
import IndexReservation from '../views/operations/reservations/IndexReservation.vue'
import IndexLivraison from '../views/operations/livraisons/IndexLivraison.vue'
import IndexPaiement from '../views/operations/paiements/IndexPaiement.vue'
import IndexFacture from '../views/factures/IndexFacture.vue'
import IndexTicketClient from '@/views/tickets/IndexTicket.vue'
import IndexAdresse from '@/views/adresses/IndexAdresse.vue'
import AuthenticateView from '@/auth/AuthenticateView.vue'   
import SingleReservation from '@/views/operations/reservations/SingleReservation.vue'



const routes: Array<RouteRecordRaw> = [
  {
    path: '/se-connecter',
    name: 'login',
    component: LoginView
  },
  {
    path: '/callback-success',
    name: 'callback.success',
    component: CallbackView
  },
  
   {
    path: '/authentification',
    name: 'authenticate',
    component: AuthenticateView
  },
  {
    path: '/creer-un-compte',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/verifier-mon-compte',
    name: 'account.verify',
    component: AccountVerify
  },
  {
    path: '/',
    name: 'accueil',
    component: HomeViewClient,
  },
  {
    path: '/operations/mes-courses',
    name: 'courses',
    component: IndexCourse,
  },
  {
    path: '/operations/mes-reservations/:id',
    name: 'reservations.single',
    component: SingleReservation,
  },
  {
    path: '/operations/reservations',
    name: 'reservations',
    component: IndexReservation,
  },
  {
    path: '/operations/livraisons',
    name: 'livraisons',
    component: IndexLivraison,
  },
  {
    path: '/operations/paiements',
    name: 'paiements',
    component: IndexPaiement,
  },
  {
    path: '/comptabilite/factures',
    name: 'factures',
    component: IndexFacture,
  },
  {
    path: '/tickets',
    name: 'tickets',
    component: IndexTicketClient,
  },
  {
    path: '/adresses',
    name: 'geolocalisation',
    component: IndexAdresse,
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes
})

router.beforeEach((to, from, next) => {
  const user = store.state.user; 

  if (to.name !== 'authenticate' && to.name !== 'login' && !store.state.authenticated) next({ name: 'login' })
  // Vérifier si l'utilisateur est authentifié et que le 'nom' est vide
  else if (user && !user.nom) {
    // Redirige vers la route register si l'utilisateur est authentifié mais n'a pas de nom
    if (to.name !== 'register') {
      return next({ name: 'register' });
    }
  }
  next()
})

export default router